// src/components/PortalAuthSync.jsx
import { useEffect } from "react";
import { useOrganization, useSession, useClerk } from "@clerk/clerk-react";
import { setPortalTokenProvider, setPortalTenantSlugProvider, setPortalSignOutCallback } from "../api";

export async function getPortalSessionToken(session) {
  if (!session) return null;
  const token = await session.getToken();
  return token || null;
}

export default function PortalAuthSync() {
  const { organization } = useOrganization();
  const { session } = useSession();
  const clerk = useClerk(); // ✅ NEW: Get Clerk instance for signOut

  useEffect(() => {
    // Provide the normal Clerk session token so session-bound claims are present.
    setPortalTokenProvider(() => getPortalSessionToken(session));

    // Provide current org slug to the API (or null if none)
    const slug = organization?.slug || null;
    setPortalTenantSlugProvider(() => slug);

    // ✅ NEW: Provide sign-out callback for when session expires
    setPortalSignOutCallback(async () => {
      try {
        console.log("[PortalAuthSync] Signing out of Clerk due to session expiry");
        await clerk.signOut();
        console.log("[PortalAuthSync] Clerk sign-out complete");
      } catch (err) {
        console.error("[PortalAuthSync] Sign-out failed:", err);
        // Don't throw - we still want to redirect to login
      }
    });

    // Cleanup on unmount/sign-out
    return () => {
      setPortalTokenProvider(null);
      setPortalTenantSlugProvider(null);
      setPortalSignOutCallback(null); // ✅ NEW: Clean up callback
    };
  }, [organization?.slug, session, clerk]); // ✅ NEW: Added clerk to dependencies

  return null;
}
